/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Subtitle_Export_PositioningInputs */

const en_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positioning`)
};

const fr_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionnement`)
};

const de_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Positionierung`)
};

const it_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posizionamento`)
};

const ru_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Позиционирование`)
};

const es_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posicionamiento`)
};

const zh_cn2_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`定位`)
};

const ja_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポジショニング`)
};

const hi_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पोजिशनिंग`)
};

const pt_pt2_subtitle_export_positioning = /** @type {(inputs: Subtitle_Export_PositioningInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Posicionamento`)
};

/**
* | output |
* | --- |
* | "Positioning" |
*
* @param {Subtitle_Export_PositioningInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_export_positioning = /** @type {((inputs?: Subtitle_Export_PositioningInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Export_PositioningInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_subtitle_export_positioning(inputs)
	if (locale === "de") return de_subtitle_export_positioning(inputs)
	if (locale === "it") return it_subtitle_export_positioning(inputs)
	if (locale === "ru") return ru_subtitle_export_positioning(inputs)
	if (locale === "es") return es_subtitle_export_positioning(inputs)
	if (locale === "zh-CN") return zh_cn2_subtitle_export_positioning(inputs)
	if (locale === "ja") return ja_subtitle_export_positioning(inputs)
	if (locale === "hi") return hi_subtitle_export_positioning(inputs)
	if (locale === "pt-PT") return pt_pt2_subtitle_export_positioning(inputs)
	return en_subtitle_export_positioning(inputs)
});